<template>
    <div class="file-preview-image-container images" v-viewer>
        <img :src="getProxyConvertedURL(fileUrl)" @error="replaceByDefaultImage" alt="" style="max-width: 100%;max-height: 92.5%;">
    </div>
</template>

<script>
 import 'viewerjs/dist/viewer.css'
  import VueViewer from 'v-viewer'
  import Vue from 'vue'
  import Utils from "../../components.utils.js";

  Vue.use(VueViewer);
  VueViewer.setDefaults({
      button:false,
      title:false,
      zoomOnTouch:false,
      slideOnTouch:false,
      navbar:false,
      toolbar:{
          zoomIn: 1,
          zoomOut:3,
          reset:2,
      },
     options:{
         show:true,
     }
  })
export default {
  name:'ImageFilePreview',
  props:['url'],
  data(){
      return {
          fileUrl:'',
      }
  },
  methods:{
    replaceByDefaultImage(e){
      e.target.onerror = null
      e.target.src = Utils.getNoThumbnailImg();
    },
  },
  mounted(){
      this.fileUrl = this.url;
  }
}
</script>

<style>

</style>